import { cn, FormLabel } from '@ds';
import { PropsWithChildren } from 'react';

type AdminFormRowProps = {
  title: string;
  isRequired?: boolean;
  wrapperClass?: string;
  inputWrapperClass?: string;
  labelClass?: string;
  center?: boolean;
  gap?: 'sm' | 'md';
};

export const AdminFormRow = ({
  title,
  isRequired = false,
  children,
  wrapperClass,
  inputWrapperClass = 'max-w-160',
  labelClass = 'text-base-30 w-28 shrink-0',
  center = true,
  gap = 'sm',
}: PropsWithChildren<AdminFormRowProps>) => {
  const colGap = gap === 'sm' ? 'gap-2' : 'gap-4';
  const wrapperClassNames = wrapperClass ?? `flex ${cn({ 'items-center': center })} ${colGap}`;

  return (
    <div className={wrapperClassNames}>
      <FormLabel className={labelClass} as="span" isRequired={isRequired}>
        {title}
      </FormLabel>
      <div className={`w-full ${inputWrapperClass}`}>{children}</div>
    </div>
  );
};
